<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions">
                <v-layout row wrap>
                    <v-flex xs2>
                        <v-select v-model="search.merchant" :items="merchantOptions" item-text="merchantName" item-value="mid" class="clearing-institute" dense clearable @click:clear="resetFilter(search.merchant)" label="Merchant Accounts" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.uuid" append-icon="search" label="UUID" clearable @click:clear="resetFilter(search.uuid)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.status" dense :items="statusOptions" label="Status" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.holder" append-icon="search" label="Card Holder" clearable @click:clear="resetFilter(search.holder)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.paymentType" :items="paymentTypeOptions" label="Payment Type" multiple dense append-icon="search" @change="searchTransactions">
                           <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span>{{ item.text }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{ search.paymentType.length - 1 }} others)</span>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.merchantTransactionId" append-icon="search" label="Merchant Transaction ID" clearable @click:clear="resetFilter(search.merchantTransactionId)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.paymentBrand" :items="paymentBrandOptions" dense label="Payment Brand" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.amount" append-icon="search" label="Amount" clearable @click:clear="resetFilter(search.amount)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="search.fromDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.fromDate" :first-day-of-week="1" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="search.toDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.toDate" label="To Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.toDate" :first-day-of-week="1" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                        <v-data-table id="transactions-table" :headers="tableHeaders" :items="transactions" :rows-per-page-items="rowsPerPage" :loading="loading" class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td v-if="props.item.status == 1" class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="green">
                                        done
                                    </v-icon>
                                </td>
                                <td v-else-if="props.item.status == 0" class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="red">
                                        clear
                                    </v-icon>
                                </td>
                                <td v-else class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="blue">
                                        history
                                    </v-icon>
                                </td>
                                <td class="text-xs-left">{{ props.item.processingTime }}</td>
                                <td class="text-xs-left">{{ props.item.merchantName }}</td>
                                <td class="text-xs-left">{{ props.item.uuid }}</td>
                                <td class="text-xs-left">{{ props.item.firstName }} {{ props.item.surname }}</td>
                                <td class="text-xs-left">{{ props.item.paymentType }}</td>
                                <td class="text-xs-left">{{ props.item.merchantTransactionId }}</td>
                                <td v-if="props.item.paymentBrand == 'VISA' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'VISA' && props.item.paymentType == '3D'" class="text-xs-left">
                                    <div class="verified-by-visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'VISAELECTRON' || props.item.paymentBrand == 'VISADEBIT'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MASTER' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="mastercard payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MASTER' && props.item.paymentType == '3D'" class="text-xs-left">
                                    <div class="mastercard-securecode payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'AMEX'" class="text-xs-left">
                                    <div class="amex payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MAESTRO'" class="text-xs-left">
                                    <div class="maestro payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'JCB'" class="text-xs-left">
                                    <div class="jcb payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'DINERS'" class="text-xs-left">
                                    <div class="diners payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'DISCOVER'" class="text-xs-left">
                                    <div class="discover payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'BCMC'" class="text-xs-left">
                                    <div class="bcmc payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'CHINAUNIONPAY'" class="text-xs-left">
                                    <div class="chinaunionpay payment-brand"></div>
                                </td>
                                <td v-else class="payment-brand-text">{{ props.item.paymentBrand }}</td>
                                <td class="text-xs-left">{{ props.item.amount }}</td>
                                <td class="text-xs-left">{{ props.item.currency }}</td>
                                <!-- <td class="text-xs-left">
                                    <v-btn icon @click="openDialog(props.item); tranInfo = props.item;">
                                        <v-icon color="grey">info</v-icon>
                                    </v-btn>         
                                </td>     -->
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment'
    import TransactionInformation from '../components/TransactionInformation.vue';

    export default {
        data() {
            return {
                pagination: { 'sortBy': 'processing_time', 'descending': true },
                search: {
                    uuid: null,
                    status: null,
                    holder: null,
                    paymentType: [],
                    merchantTransactionId: null,
                    paymentBrand: null,
                    amount: null,
                    merchant: null,
                    fromDate: new Date().toISOString().substr(0, 10),
                    toDate: new Date().toISOString().substr(0, 10)
                },        
                statusOptions: [
                            { value: null, text: "All" },
                            { value: 0, text: "Failed" },
                            { value: 1, text: "Success" },
                            { value: 2, text: "Pending" }
                ],
                paymentTypeOptions: [
                                { value: "DB", text: "Debit" },
                                { value: "RF", text: "Refund" },
                ],
                paymentBrandOptions: [
                                { value: null, text: "All" },
                                { value: "AMEX", text: "AMEX" },
                                { value: "BCMC", text: "BCMC" },
                                { value: "CHINAUNIONPAY", text: "CHINAUNIONPAY" },
                                { value: "DINERS", text: "DINERS" },
                                { value: "DISCOVER", text: "DISCOVER" },
                                { value: "JCB", text: "JCB" },
                                { value: "MAESTRO", text: "MAESTRO" },
                                { value: "MASTER", text: "MASTERCARD" },
                                { value: "PAYSAFECARD", text: "PAYSAFECARD" },
                                { value: "VISA", text: "VISA" },
                                { value: "VISADEBIT", text: "VISADEBIT" },
                                { value: "VISAELECTRON", text: "VISAELECTRON" }
                ],
                rowsPerPage:[10, 25, 50, 100],
                loading: true,
                transactions: [],
                tableHeaders: [{ text: 'Status', sortable: false, align: 'center' },
                               { text: 'Date', sortable: false },
                               { text: 'Merchant', sortable: false },
                               { text: 'UUID', sortable: false },
                               { text: 'Card Holder', value: 'holder', sortable: false },
                               { text: 'Payment Type', value: 'payment_type', sortable: false },
                               { text: 'Merchant Transaction ID', value: 'merchantTransactionId', sortable: false },
                               { text: 'Payment Brand', value: 'paymentBrand', sortable: false, align: 'center' },
                               { text: 'Amount', value: 'amount', sortable: false },
                               { text: 'Currency', value: 'currency', sortable: false }],
                fromDateModal: false,
                toDateModal: false,
                tranInfoDialog: false,
                tranInfo: null,
                merchantOptions: []
            }
        },
        beforeMount() {
            this.getMerchants();
            this.getTransactions();
        },
        methods: {
            getTransactions() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-netbanx',
                data: { },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactions = response.data;
                    this.loading = false;
                    // console.log(this.transactions);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            searchTransactions() {
                this.loading = true;
                
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/search-transactions-netbanx',
                data: { search: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactions = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getMerchants() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-merchants-netbanx',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    let temp = [];
                    response.data.forEach((e) => {
                        this.merchantOptions.push({ mid: e.mid, merchantName: `${e.mid} - ${e.merchantName}` });
                    });
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            resetFilter(field) {
                this.field = null;
                this.searchTransactions();
            },
            handleDateChange() {
                if(this.search.toDate < this.search.fromDate) {
                    this.search.fromDate = this.search.toDate;
                }
                this.$refs.fromDateDialog.save(this.search.fromDate);
                this.$refs.toDateDialog.save(this.search.toDate);
                this.searchTransactions();
            }
        }
    }
</script>

<style>
   
</style>